var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.89,
    height: 28.89,
    viewBox: "0 0 28.89 28.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0V28.89H28.89V0ZM22.705,11.119A11.238,11.238,0,0,1,5.417,21.1a7.95,7.95,0,0,0,5.85-1.636,3.955,3.955,0,0,1-3.691-2.745A3.973,3.973,0,0,0,9.36,16.65a3.955,3.955,0,0,1-3.169-3.924,3.931,3.931,0,0,0,1.789.495A3.959,3.959,0,0,1,6.757,7.945,11.219,11.219,0,0,0,14.9,12.074a3.954,3.954,0,0,1,6.734-3.6,7.907,7.907,0,0,0,2.51-.958A3.963,3.963,0,0,1,22.408,9.7a7.919,7.919,0,0,0,2.269-.622,8.073,8.073,0,0,1-1.972,2.043Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.19848f850aa10587d8575b38fad7b64d.svg";
export { ForwardRef as ReactComponent };